export const DEFAULT_MYAUCTION_LIST_LENGTH = 50;
export const AUCTION_STATUSES = Object.freeze({
  INPRODUCTION: 'InProduction',
  READY: 'Ready',
  AUCTIONPREVIEW: 'AuctionPreview',
  ONGOING: 'Ongoing',
  END: 'End',
  SELLERPENDING: 'SellerPending',
  CLOSED: 'Closed',
  CANCELED: 'Canceled'
});
export const AUCTION_TYPES = Object.freeze({
  JTA: 'JTA',
  FlashSale: 'JLA',
  Catalog: 'Catalog'
});
export const AUCTION_TYPES_OPTIONS = [
  { label: 'Jewlery Tender', value: 'JTA' },
  { label: 'JLA', value: 'FlashSale' },
  { label: 'Jewlery Catalog', value: 'Catalog' }
];

export const DELIVERY_LOCATIONS = [
  { value: '', label: 'Select' },
  { value: 'NY', label: 'New York' },
  { value: 'RG', label: 'Ramat Gan' },
  { value: 'India', label: 'India' }
];

export const LISTING_STATUS_OPTIONS = [
  { label: 'Active', value: 'Active' },
  { label: 'Sold', value: 'Sold' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Not Sold', value: 'NotSold' },
  { label: 'New', value: 'New' },
  { label: 'Preview', value: 'ReadOnly' }
];

export const AUCTION_STATUS_OPTIONS = Object.freeze([
  { label: 'All', value: '' },
  { label: 'In Production', value: 'inProduction' },
  { label: 'Ready', value: 'ready' },
  { label: 'Auction Preview', value: 'auctionPreview' },
  { label: 'Ongoing Auction', value: 'ongoing' },
  { label: 'Bidding Closed', value: 'end' },
  { label: 'Sellers Notified', value: 'sellerPending' },
  { label: 'Auction Closed', value: 'closed' },
  { label: 'Canceled', value: 'canceled' }
]);

export const AUCTIONS_SORT = [
  {
    value: { sortType: 'EstimateLow', sortOrderDesc: false },
    label: 'Estimate (low to high)'
  },
  {
    value: { sortType: 'EstimateHigh', sortOrderDesc: true },
    label: 'Estimate (high to low)'
  }
];

export const AUCTIONS_SORT_MOBILE = [
  {
    value: { sortType: 'EstimateLow', sortOrderDesc: false },
    label: 'Estimate (low to high)'
  },
  {
    value: { sortType: 'EstimateHigh', sortOrderDesc: true },
    label: 'Estimate (high to low)'
  }
];

export const auctionsStatuses = Object.freeze({
  InProduction: {
    name: 'InProduction',
    auctionStatusSelect: 'In Production',
    finalPrice: false,
    MaxBidSet: false,
    onlyInPreview: false,
    activeAuction: false,
    closeAuction: false,
    onlyMyListings: true,
    onlyMyBids: false
  },
  Ready: {
    name: 'Ready',
    auctionStatusSelect: 'Ready',
    finalPrice: false,
    MaxBidSet: false,
    onlyInPreview: false,
    activeAuction: false,
    closeAuction: false,
    onlyMyListings: true,
    onlyMyBids: false
  },
  AuctionPreview: {
    name: 'AuctionPreview',
    auctionStatusSelect: 'Auction Preview',
    finalPrice: false,
    MaxBidSet: false,
    onlyInPreview: true,
    activeAuction: false,
    closeAuction: false,
    onlyMyListings: true,
    onlyMyBids: false
  },
  Ongoing: {
    name: 'Ongoing',
    auctionStatusSelect: 'Ongoing Auction',
    finalPrice: false,
    MaxBidSet: false,
    onlyInPreview: false,
    activeAuction: true,
    closeAuction: false,
    onlyMyListings: true,
    onlyMyBids: true
  },
  End: {
    name: 'End',
    auctionStatusSelect: 'Bidding Closed',
    finalPrice: false,
    MaxBidSet: false,
    onlyInPreview: false,
    activeAuction: false,
    closeAuction: true,
    onlyMyListings: true,
    onlyMyBids: true
  },
  SellerPending: {
    name: 'SellerPending',
    auctionStatusSelect: 'Sellers Notified',
    finalPrice: true,
    MaxBidSet: true,
    onlyInPreview: false,
    activeAuction: false,
    closeAuction: true,
    onlyMyListings: true,
    onlyMyBids: true
  },
  Closed: {
    name: 'Closed',
    auctionStatusSelect: 'Auction Closed',
    finalPrice: true,
    MaxBidSet: true,
    onlyInPreview: false,
    activeAuction: false,
    closeAuction: true,
    onlyMyListings: true,
    onlyMyBids: true
  },
  Canceled: {
    name: 'Canceled',
    auctionStatusSelect: 'Cancelled',
    finalPrice: false,
    MaxBidSet: false,
    onlyInPreview: false,
    activeAuction: false,
    closeAuction: false,
    onlyMyListings: false,
    onlyMyBids: true
  }
});
